import * as React from 'react';

import './UiLoader.scss';

export default function UiLoader() {
  return (
    <div className="loading" />
  );
}
